<app-shared-loading *ngIf="loading" [hintText]="'process-Order-Info-2-Title' | translation | async"></app-shared-loading>
<footer *ngIf="disPlayEnable">
    <div class="flexbox">
        <div class="column">
            <a *ngIf="urlReturnMerchant" title="volver a {{ user.MERCHANT_NAME }}" class="returnMerchant" [href]="urlReturnMerchant | safe">
                <fa-icon icon="arrow-left" size="lg"></fa-icon> Volver a {{ user.MERCHANT_NAME }}
            </a>
        </div>
        <div class="row logos" *ngIf="!RemoveFooterLogosFf">
            <img src="../../../assets/images/gs.png" id="_logo_seguridad" alt="_logo_seguridad" />
            <img src="../../../assets/images/pci-dss-logo.png" id="_logo_cloudflare" alt="_logo_cloudflare" />
            <img src="../../../assets/images/cloudflare.png" id="_logo_pci" alt="_logo_pci" />
        </div>
    </div>
</footer>
